import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=24df2448&scoped=true&"
import script from "./PaymentDescription.vue?vue&type=script&lang=js&"
export * from "./PaymentDescription.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=24df2448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df2448",
  null
  
)

export default component.exports